module.exports = __webpack_public_path__ + "assets/delivery-e99090.svg";